// src/services/api/boltJr/videosApi.ts
import { createApiService } from '../base';
import { BoltVideoItem } from '../../../types/bolt-jr';

const videosService = createApiService<BoltVideoItem>('videos', 'bolt-jr');

export const fetchBoltVideos = videosService.getAll;
export const fetchBoltVideo = videosService.getOne;
export const createBoltVideo = videosService.create;
export const updateBoltVideo = videosService.update;
export const deleteBoltVideo = videosService.delete;
export const updateBoltVideosOrder = videosService.updateOrder;
